import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pr-3 h-full flex flex-col" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "font-bold truncate" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont text-subtle text-xs" }, "", -1)
const _hoisted_5 = { class: "text-subtle text-sm py-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-subtle text-sm py-1"
}
const _hoisted_7 = {
  name: "群所在的服务器",
  "no-checkbox": true,
  online: true,
  class: "my-2 w-full h-18 bg-gray-1 px-3 rounded-sm flex flex-col justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "群所在的服务器", -1)
const _hoisted_9 = { class: "pt-1 text-sm text-subtle" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "break-all line-clamp-1" }, "添加成员", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "break-all line-clamp-1" }, "移除成员", -1)

import { defineAsyncComponent, ref } from 'vue'
import { Dialog } from 'quasar'
import { useChatGroupStore } from '@/store/user-chat-group'
import { useGroupProfile } from '@/composables/user/useGroupProfile'
import { debouncedWatch } from '@vueuse/core'
import { ChatGroupMember } from '@/types/user-chat-group'
import { useUserProfile } from '@/composables/user/useUserProfile'
import DrawerGroupNameEditDialogVue from './DrawerGroupNameEditDialog.vue'
import AddMemberVue from './add-member-dialog/AddMember.vue'
import RemoveMemberVue from './remove-member-dialog/RemoveMember.vue'
interface SearchableMember extends ChatGroupMember {
    address: string
    nickname?: string
    remark?: string
    groupName?: string
    oaName?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    hostId: null,
    groupId: null
  },
  setup(__props: any) {

const props = __props as {
    /** 群所在的服务器地址 */
    hostId: string
    /** 群 id */
    groupId: string
}

const DrawerGroupMemberVue = defineAsyncComponent(() => import('./DrawerGroupMember.vue'))



const { displayName, groupProfile, connectionState } = useGroupProfile(props)

useChatGroupStore().getMemberList(props.hostId, props.groupId)

function openEditGroupNameDialog() {
    Dialog.create({
        component: DrawerGroupNameEditDialogVue,
        componentProps: { groupInfo: groupProfile.value },
    })
}

// 搜索群成员
const searchValue = ref('')
const filterdMembers = ref<SearchableMember[] | null>(null)

debouncedWatch(
    searchValue,
    (inputValue) => {
        if (!inputValue || !groupProfile.value || !groupProfile.value.members) {
            filterdMembers.value = null
            return
        }

        const members = groupProfile.value.members
        const searchableMembers = members.map((m) => {
            const { userProfile } = useUserProfile(m.memberId)
            return {
                ...m,
                address: m.memberId,
                nickname: userProfile.value?.nickname,
                remark: userProfile.value?.remark,
                groupName: m.memberName,
                oaName: userProfile.value?.staffInfo?.name,
            } as SearchableMember
        })
        filterdMembers.value = searchableMembers.filter((member) => {
            const { nickname, remark, groupName, oaName, address } = member
            return (
                nickname?.includes(inputValue) ||
                remark?.includes(inputValue) ||
                groupName?.includes(inputValue) ||
                oaName?.includes(inputValue) ||
                address.includes(inputValue)
            )
        })
    },
    { debounce: 400 }
)

function addMembers() {
    Dialog.create({
        component: AddMemberVue,
        componentProps: props,
    }).onOk(() => {
        useChatGroupStore().getMemberList(props.hostId, props.groupId)
    })
}

function removeMembers() {
    Dialog.create({
        component: RemoveMemberVue,
        componentProps: { members: groupProfile.value?.members, ...props },
    }).onOk(() => {
        useChatGroupStore().getMemberList(props.hostId, props.groupId)
    })
}

return (_ctx: any,_cache: any) => {
  const _component_base_btn = _resolveComponent("base-btn")!
  const _component_BaseSearchInput = _resolveComponent("BaseSearchInput")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(displayName)), 1),
      ([1, 2].includes(_unref(groupProfile)?.person.memberType || 0))
        ? (_openBlock(), _createBlock(_component_base_btn, {
            key: 0,
            onClick: openEditGroupNameDialog,
            round: "",
            color: "white",
            "text-color": "subtle",
            dense: "",
            class: "m-1"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_5, "群号 " + _toDisplayString(_unref(groupProfile)?.markId), 1),
    (_unref(groupProfile)?.publicName !== _unref(groupProfile)?.name)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, " 公开群名: " + _toDisplayString(_unref(groupProfile)?.publicName), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createTextVNode(_toDisplayString(__props.hostId) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass([
                        _unref(connectionState) === 'connected'
                            ? 'bg-positive'
                            : _unref(connectionState) === 'not-exist'
                            ? 'bg-subtle'
                            : 'bg-negative'
                    , "ml-1.5 w-2.5 h-2.5 inline-block rounded-md"])
        }, null, 2)
      ])
    ]),
    (_unref(groupProfile))
      ? (_openBlock(), _createBlock(_component_q_scroll_area, {
          key: 1,
          class: "flex-grow pt-2 pr-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseSearchInput, {
              modelValue: searchValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
              class: "mb-4"
            }, null, 8, ["modelValue"]),
            (
                    !filterdMembers.value && (_unref(groupProfile).joinType === 0 || [1, 2].includes(_unref(groupProfile).person.memberType))
                )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: addMembers,
                  class: "flex items-center h-10 my-1 cursor-pointer"
                }, [
                  _createVNode(_component_q_avatar, {
                    size: "30px",
                    rounded: "",
                    class: "mr-2.5",
                    color: "secondary",
                    "text-color": "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "add" })
                    ]),
                    _: 1
                  }),
                  _hoisted_10
                ]))
              : _createCommentVNode("", true),
            (!filterdMembers.value && [1, 2].includes(_unref(groupProfile).person.memberType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: removeMembers,
                  class: "flex items-center h-10 my-1 cursor-pointer"
                }, [
                  _createVNode(_component_q_avatar, {
                    size: "30px",
                    rounded: "",
                    class: "mr-2.5",
                    color: "secondary",
                    "text-color": "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "remove" })
                    ]),
                    _: 1
                  }),
                  _hoisted_11
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterdMembers.value || _unref(groupProfile)?.members, (member) => {
              return (_openBlock(), _createBlock(_unref(DrawerGroupMemberVue), {
                key: member.memberId,
                member: member,
                "chat-group": _unref(groupProfile)
              }, null, 8, ["member", "chat-group"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})